module.exports = __webpack_public_path__ + "img/서비스비전.6ed4822d.png";